module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../../../node_modules/happypack/loader.js?id=jsx!./ProgressView.js"));
	}, "AfterSaleDetailProgressView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=AfterSaleDetailProgressView!./src/pages/Shop/Member/TradeManage/AfterSale/AfterSaleDetail/Progress/ProgressView.js
// module id = 1036
// module chunks = 438